<template>
  <div style="background: #fff;">
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Order History</el-breadcrumb-item>
      <el-breadcrumb-item>Review Order</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="font-size:24px;font-weight:bold;color:#343434;margin-left:32px;height:82px;line-height:82px;">
      <span>Customer number :</span>
      <span>{{ this.orderDetail.userId }}</span>
      <span style="margin-left:70px;">Submitted time :</span>
      <span>{{ this.orderDetail.submittedTime }}</span>
    </div>
    <div style="margin:0 20px;width:auto;height:58px;line-height:58px;font-size:24px;font-weight:bold;color:#00546a;background:#f5f5f5;padding-left:32px;">Order Details</div>
    <div style="margin:0 20px 36px;width:auto;display:flex;">
      <div style="flex:3;padding-left:36px;font-size:18px;color:#000;">
        <p style="margin:36px 0 10px 0;font-weight:bold;">SHIPPING METHOD</p>
        <p style="color:#343434;">{{ this.orderDetail.shippingMethod }}</p>
        <p style="margin:36px 0 10px 0;font-weight:bold;">CUSTOMER NUMBER</p>
        <p style="color:#343434;">{{ this.orderDetail.userId }}</p>
        <p style="margin:36px 0 10px 0;font-weight:bold;">EMAIL ADDRESS</p>
        <p style="color:#343434;">{{ this.orderDetail.emailAddress }}</p>
      </div>
      <div style="flex:3;padding-left:36px;font-size:18px;color:#000;">
        <p style="margin:36px 0 10px 0;font-weight:bold;">BACKORDER SHIPPING METHOD</p>
        <p style="color:#343434;">{{ this.orderDetail.backorderShippingMethod }}</p>
        <p style="margin:36px 0 10px 0;font-weight:bold;">PAYMENT METHOD</p>
        <p style="color:#343434;">{{ this.orderDetail.paymentMethod }}</p>
        <p style="margin:36px 0 10px 0;font-weight:bold;">PURCHASE ORDER</p>
        <p style="color:#343434;">{{ this.orderDetail.purchaseOrder }}</p>
      </div>
      <div style="flex:3;padding-left:36px;font-size:18px;color:#000;">
        <p style="margin:36px 0 10px 0;font-weight:bold;">SHIPPING ADDRESS</p>
        <!-- <p style="width:180px;word-wrap: break-word;color:#343434;"> </p> -->
        <p style="fcolor:#343434;line-height:26px;">
          <span>{{ this.orderDetail.shippingLastName }} </span> <span>{{ this.orderDetail.shippingFirstName }}</span>
        </p>
        <p style="color:#343434;line-height:26px;">
          <span>{{ this.orderDetail.shippingStreetAddress }} </span> <span>{{ this.orderDetail.shippingCity }}</span> <span>{{ this.orderDetail.shippingStateSelectState }}</span>
        </p>
        <p style="color:#343434;line-height:26px;">
          <span>{{ this.orderDetail.shippingCountryUnitedStates }} </span>
        </p>
        <p style="color:#343434;line-height:26px;">
          <span>{{ this.orderDetail.shippingPhone }} </span>
        </p>
        <p style="margin:36px 0 10px 0;font-weight:bold;">BILLING ADDRESS</p>
        <!-- <p style="width:180px;word-wrap: break-word;color:#343434;">{{}}</p> -->
        <p style="fcolor:#343434;line-height:26px;">
          <span>{{ this.orderDetail.billingLastName }} </span> <span>{{ this.orderDetail.billingFirstName }}</span>
        </p>
        <p style="color:#343434;line-height:26px;">
          <span>{{ this.orderDetail.billingStreetAddress }} </span> <span>{{ this.orderDetail.billingCity }}</span> <span>{{ this.orderDetail.billingStateSelectState }}</span>
        </p>
        <p style="color:#343434;line-height:26px;">
          <span>{{ this.orderDetail.billingCountryUnitedStates }} </span>
        </p>
        <p style="color:#343434;line-height:26px;">
          <span>{{ this.orderDetail.billingPhone }} </span>
        </p>
      </div>
    </div>
    <div style="margin:0 20px;width:auto;height:58px;line-height:58px;font-size:24px;font-weight:bold;color:#00546a;background:#f5f5f5;padding-left:32px;">Invoice and Shipping Information</div>
    <div style="margin:0 20px;width:auto;border-bottom:1px solid #e1e1e1;height:94px;line-height:94px;color:#8d8d8d;font-size:24px;">
      <span style="margin:0 212px 0 35px;">Invoice</span>
      <span>Track shipping</span>
    </div>
    <div style="margin:0 20px 20px;width:auto;border-bottom:1px solid #e1e1e1;min-height:94px;line-height:94px;color:#343434;font-size:24px;">
      <img style="margin:0 212px 0 35px;" :src=this.orderDetail.invoicePath />
      <span>{{ this.orderDetail.trackShipping }}</span>
    </div>
  </div>
</template>
<script>
    import { orderDetail } from '@/api/Persona/index' ;
    export default {
        name: 'Orderdetail',
        data () {
            return {
              orderId: '',
              orderDetail: {},
            }
        },
        created() {
          console.log(this.$route, 'this.$route');
          console.log(this.$route.query, 'this.$route.query');
          this.id = this.$route.query.id
          this.getOrderDetail(this.id)
        },
        mounted() {},
        methods: {
          getOrderDetail(orderId) {
            orderDetail({orderId : orderId}).then((res) => {
              console.log(res, 'orderDetail');
              this.orderDetail = res;
            });
          },
        },
    }
</script>

<style scoped>
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  color:#000000;
  padding-left: 30px;
}
</style>